import eventActions from './actions';
import storeResourceFactory from '../../libs/storeResourceFactory';

const mealEventsStore = storeResourceFactory('mealEvents', []);

const state = {
  ...mealEventsStore.state,
};

const actions = {
  initializeEvents: mealEventsStore.request(eventActions.initializeEvents),
};

const mutations = {
  ...mealEventsStore.mutations,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./store/modules/events/index.js